import { MenuItem } from "@/components/Sidebar";
import {
  ADMIN_STANDARDS_REPORT_PAGE,
  ADMIN_WRITING_REPORT_PAGE,
  CLASSROOM_DATA_PAGE,
  CLASSROOM_POWER_WORDS_PAGE,
  STUDENT_MY_PROGRESS_PAGE,
  USAGE_REPORT_PAGE,
} from "@/reports/constants";

export const ALL_REPORTS_SIDEBAR_MENU_ITEMS: MenuItem[] = [
  {
    id: "reports",
    title: "Reports",
    options: [
      CLASSROOM_DATA_PAGE,
      CLASSROOM_POWER_WORDS_PAGE,
      USAGE_REPORT_PAGE,
      ADMIN_STANDARDS_REPORT_PAGE,
      ADMIN_WRITING_REPORT_PAGE,
      STUDENT_MY_PROGRESS_PAGE,
    ],
  },
];

export const REPORTS_ROOT_BREADCRUMB = {
  contents: "Reports",
};
